import type { VariantProps } from '@gluestack-ui/utils/nativewind-utils'
import React from 'react'
import { vstackStyle } from './styles'

type IVStackProps = React.ComponentProps<'div'> & VariantProps<typeof vstackStyle>

const VStack = React.forwardRef<React.ComponentRef<'div'>, IVStackProps>(function VStack(
  { className, space, reversed, ...props },
  ref
) {
  return <div className={vstackStyle({ space, reversed, class: className } as NonNullable<Parameters<typeof vstackStyle>[0]>)} {...props} ref={ref} />
})

VStack.displayName = 'VStack'

export { VStack }
